import React from 'react';
import { Icon } from '~/lib/bn-material-ui';
import { BinLevelFillStripes } from './bin-unmonitored-fill';
import classnames from 'classnames';
import useBinLevelStyles from './bin-level-styles';

export default function BinLevelUnknown({ className, height, width }) {
  const styles = useBinLevelStyles();

  return (
    <div className={styles.box} style={{
      ...height !== undefined ? { height } : {},
      ...width !== undefined ? { width } : {},
    }}>
      <div className={classnames(styles.barContainer, styles.stripes, className)}>
        <BinLevelFillStripes />
        <Icon className={`fas fa-question ${styles.icon}`} style={{ fontSize: '1.5rem' }} />
      </div>
    </div>
  );
}
